var CONFUSEDCMS = CONFUSEDCMS || {},
    CONFUSEDPETROLPRICES = CONFUSEDPETROLPRICES || {},
    Confused = Confused || {},
    newrelic = newrelic || {};

(function (ns, $) {
    'use strict';

    // html elements
    ns.Elements = {
        SFPostcode: '#sfPostcode',
        SFRadius: '#sfRadius',
        SFPostcodeError: '#sfPostcodeError',
        RSPostcode: '#rsPostcode',
        RSFuelTypeDefaultOption: '#rsFuelType option[value=\'0\']',
        RSPostcodeError: '#rsPostcodeError',
        ScrollPricesRightLink: '.petrol-price-results__link--right',
        ScrollPricesLeftLink: '.petrol-price-results__link--left',
        ShowingNumberOfPrices: '#showingNumberOfPrices',
        ShowingNumberOfPricesTokenized: '#showingNumberOfPricesTokenized',
        IsOpenFilter: '#open-now-check',
        SortPricesByCheapest: '#sortPricesByCheapest',
        SortPricesByDistance: '#sortPricesByDistance',
        PetrolPriceCalculator: 'div.petrol-price-calculator',
        DirectionsApiLink: '#directionsApiLink'
    };

    // css classes
    ns.Classes = {
        ResultsFilterActive: 'results-filter--active'
    };

    // constants
    ns.Constants = {
        AppleMaps: 'http://maps.apple.com/maps?',
        AndroidMaps: 'geo:',
        HttpsMaps: 'https://maps.google.com/?',
        IPhone: 'iPhone',
        IPod: 'iPod',
        IPad: 'iPad',
        Android: 'android',
        AuthPromptCookieName: 'AuthPrompt',
        PriceNumberOfDecimalPlaces: 1,
        DistanceNumberOfDecimalPlaces: 1,
        SavingsNumberOfDecimalPlaces: 2,
        MyLocation: 'My location',
        Radius5Miles: 5,
        Radius10Miles: 10,
        Radius25Miles: 25,
        PriceTypeMock: 3,
        RequestSourceShowMoreResults: 'ShowMoreResults',
        RequestSourceAutoSearch: 'AutoSearch',
        RequestSourceSearchForm: 'SearchForm',
        RequestSourceResultsForm: 'ResultsForm',
        CurrentLocationUnavailable: 'Unable to find current location',
        CurrentLocationError: 'Unable to find current location',
        Station: 'station',
        Stations: 'stations',
        PriceStatisticDefaultValue: '-',
        PetrolAppName: 'PetrolPrices'
    };

    // tokens
    ns.Tokens = {
        NumberOfPrices: '[#NumberOfPrices]'
    };

    // utils functions
    ns.Utils = {

        // bind json price to model
        BindPrice: function (price, jsonPrice) {
            price.CategoryNumber(jsonPrice.CategoryNumber);
            price.Brand(jsonPrice.Brand);
            price.SiteName(jsonPrice.SiteName);
            price.Street(jsonPrice.Street);
            price.Suburb(jsonPrice.Suburb);
            price.Town(jsonPrice.Town);
            price.County(jsonPrice.County);
            price.Postcode(jsonPrice.Postcode);
            price.FormattedAddress(jsonPrice.FormattedAddress);
            price.Longitude(jsonPrice.Longitude);
            price.Latitude(jsonPrice.Latitude);
            price.FuelTypeId(jsonPrice.FuelTypeId);
            price.DateOfPrice(ns.Utils.FormatDateOfPrice(jsonPrice.DateOfPrice));
            price.ModalPrice(jsonPrice.ModalPrice.toFixed(ns.Constants.PriceNumberOfDecimalPlaces));
            price.Distance(jsonPrice.Distance.toFixed(ns.Constants.DistanceNumberOfDecimalPlaces));
            price.Logo(jsonPrice.Logo);
            price.Savings(jsonPrice.Savings.toFixed(ns.Constants.SavingsNumberOfDecimalPlaces));
            price.Ranking(jsonPrice.Ranking);
            price.OpeningTime(jsonPrice.OpeningTime);
            price.ClosingTime(jsonPrice.ClosingTime);
            price.Fuel24Hours(jsonPrice.Fuel24Hours);
            price.AutomatService(jsonPrice.AutomatService);
            price.IsOpen(jsonPrice.IsOpen);
            price.IsOpenText(jsonPrice.IsOpenText);
            price.OpeningClosingTimeText(jsonPrice.OpeningClosingTimeText);
            price.OpeningHoursText(jsonPrice.OpeningHoursText);
            price.PriceType(jsonPrice.PriceType);
            price.Enabled(true);
        },

        // format date of price
        FormatDateOfPrice: function (dateOfPrice) {
            var date = new Date(Date.parse(dateOfPrice));

            var day = date.getDate();
            var month = $.datepicker.formatDate('MM', date);
            var year = date.getFullYear();

            return day + ' ' + month + ' ' + year;
        },

        // sort prices by cheapest
        SortPricesByCheapest: function (self) {
            self.Prices.sort(function (left, right) {
                var leftModalPrice = parseFloat(left.ModalPrice());
                var rightModalPrice = parseFloat(right.ModalPrice());

                return leftModalPrice === rightModalPrice ? 0 : (leftModalPrice < rightModalPrice ? - 1 : 1);
            });

            // scrollable prices
            CONFUSEDPETROLPRICES.scrollablePricesOnRender(self.countNumberOfPrices());
        },

        // sort prices by distance
        SortPricesByDistance: function (self) {
            self.Prices.sort(function (left, right) {
                var leftDistance = parseFloat(left.Distance());
                var rightDistance = parseFloat(right.Distance());

                return leftDistance === rightDistance ? 0 : (leftDistance < rightDistance ? -1 : 1);
            });

            // scrollable prices
            CONFUSEDPETROLPRICES.scrollablePricesOnRender(self.countNumberOfPrices());
        },

        // format price statistic
        FormatPriceStatistic : function (priceStatistic) {

            if (!priceStatistic) {
                return ns.Constants.PriceStatisticDefaultValue;
            }

            return priceStatistic;
        },

        // write new relic event
        WriteNewRelicPageEvent: function(eventName, eventArgs) {
            eventArgs = eventArgs || { };
            eventArgs = ns.Utils.GetCustomerFromCookies(eventArgs);
            if (newrelic && newrelic.addPageAction !== undefined){
                newrelic.addPageAction(CONFUSEDPETROLPRICES.Constants.PetrolAppName + eventName, eventArgs);
            }
        },

        // get customer from cookies
        GetCustomerFromCookies: function(object) {
            object = object || {};
            var cookies = document.cookie.split(';'),
                xUniqueCustomerSessionIdString = 'X-UniqueCustomerSessionID',
                xUniqueCustomerCookieIdString = 'X-UniqueCustomerCookieID',
                xUniqueCustomerSessionId = '',
                xUniqueCustomerCookieId = '';

            for (var c = 0; c < cookies.length; c++) {
                if (cookies[c].indexOf(xUniqueCustomerSessionIdString) !== -1) {
                    xUniqueCustomerSessionId = cookies[c].split('=')[1];
                }
                if (cookies[c].indexOf(xUniqueCustomerCookieIdString) !== -1){
                    xUniqueCustomerCookieId = cookies[c].split('=')[1];
                }
            }

            object.XUniqueCustomerSessionIDString = xUniqueCustomerSessionId;
            object.XUniqueCustomerCookieIDString = xUniqueCustomerCookieId;
            return object;
        }

    };

    // blank price
    ns.Price = function () {
        var self = this;
        self.CategoryNumber = ko.observable('');
        self.Brand = ko.observable('');
        self.SiteName = ko.observable('');
        self.Street = ko.observable('');
        self.Suburb = ko.observable('');
        self.Town = ko.observable('');
        self.County = ko.observable('');
        self.Postcode = ko.observable('');
        self.FormattedAddress = ko.observable('');
        self.Latitude = ko.observable('');
        self.Longitude = ko.observable('');
        self.FuelTypeId = ko.observable(0);
        self.DateOfPrice = ko.observable('');
        self.ModalPrice = ko.observable(0.0);
        self.Distance = ko.observable(0);
        self.Logo = ko.observable('');
        self.Savings = ko.observable(0.0);
        self.Ranking = ko.observable(0);
        self.OpeningTime = ko.observable('');
        self.ClosingTime = ko.observable('');
        self.Fuel24Hours = ko.observable('');
        self.AutomatService = ko.observable('');
        self.IsOpen = ko.observable('');
        self.IsOpenText = ko.observable('');
        self.OpeningClosingTimeText = ko.observable('');
        self.OpeningHoursText = ko.observable('');
        self.PriceType = ko.observable(0);
        self.Enabled = ko.observable(true);
    };

    // petrol prices functions
    ns.PetrolPricesForm = function () {
        var self = this;
        self.currentStep = ko.observable(1);
        self.currentFilter = ko.observable(0);
        self.currentHeader = ko.observable(0);
        self.currentRadiusSearch = ko.observable(0);
        self.currentLogin = ko.observable(0);
        self.currentNotificationBar = ko.observable(0);
        self.currentNoPrices = ko.observable(0);
        self.currentPriceListError = ko.observable(0);
        self.currentNotificationPanel = ko.observable(0);
        self.FuelType = ko.observable('');
        self.Radius = ko.observable('');
        self.Postcode = ko.observable('');
        self.PostcodeLatitude = ko.observable(0);
        self.PostcodeLongitude = ko.observable(0);
        self.Prices = new ko.observableArray();
        self.DirectionsMap = '';
        self.DirectionsRenderer = '';
        self.PetrolHighest = ko.observable(ns.Constants.PriceStatisticDefaultValue);
        self.PetrolLowest = ko.observable(ns.Constants.PriceStatisticDefaultValue);
        self.PetrolAverage = ko.observable(ns.Constants.PriceStatisticDefaultValue);
        self.PetrolLastUpdated = ko.observable(ns.Constants.PriceStatisticDefaultValue);
        self.DieselHighest = ko.observable(ns.Constants.PriceStatisticDefaultValue);
        self.DieselLowest = ko.observable(ns.Constants.PriceStatisticDefaultValue);
        self.DieselAverage = ko.observable(ns.Constants.PriceStatisticDefaultValue);
        self.DieselLastUpdated = ko.observable(ns.Constants.PriceStatisticDefaultValue);
        self.ModalOpeningHoursText = ko.observable('');
        self.ModalOpeningHoursAutomatService = ko.observable(false);
        self.NumberOfPricesWithin5Miles = ko.observable(0);
        self.NumberOfPricesWithin10Miles = ko.observable(0);
        self.NumberOfPricesWithin25Miles = ko.observable(0);
        self.IsAuthenticatedUser = ko.observable(false);
        self.IsSearching = ko.observable(false);

        // initialise form
        self.Initialise = function () {

            // bind to knockout
            ko.applyBindings(self, document.getElementById('main'));

            // init on page load
            self.initOnPageLoad();
        };

        // search form 'get prices' button
        self.getPrices = function (requestSource) {

            // ensure safari on mac yielding postcode
            if (CONFUSEDPETROLPRICES.isSafariOnMac()) {
                self.Postcode($(ns.Elements.SFPostcode).val());
            }

            // obtain form values
            var fuelType = self.FuelType();
            var radius = self.Radius();
            var postcode = self.Postcode();
            var postcodeLatitude = self.PostcodeLatitude();
            var postcodeLongitude = self.PostcodeLongitude();

            // validate form
            if (CONFUSEDPETROLPRICES.validateSearchForm(fuelType, radius, postcode, postcodeLatitude, postcodeLongitude) === false) {
                return;
            }

            // remove default '0' option from fuel type dropdown
            $(ns.Elements.RSFuelTypeDefaultOption).remove();

            // handle search form to prices
            CONFUSEDPETROLPRICES.searchFormToPrices();

            // get price list
            self.GetPriceList(fuelType, radius, postcode, postcodeLatitude, postcodeLongitude, requestSource);
            return;
        };

        // use current location lat/lng
        self.useCurrentLocation = function () {

            function processGeolocation(position) {
                CONFUSEDPETROLPRICES.Utils.WriteNewRelicPageEvent('CurrentPosition');

                // get directions api link
                var directionsApiLink = $(ns.Elements.DirectionsApiLink);
                if (directionsApiLink.length === 0) {
                    self.handleCurrentLocationFault(ns.Constants.CurrentLocationError);
                    return;
                }

                var directionsApiLinkValue = directionsApiLink.val();

                // if directions api link available, use it to get script
                if (directionsApiLinkValue) {

                    $.ajax({
                        type: 'GET',
                        url: directionsApiLinkValue,
                        dataType: 'script',
                        cache: true,
                        success: function () {

                            // clear directions api link once script retrieved
                            $(ns.Elements.DirectionsApiLink).val('');

                            // obtain address
                            self.obtainCurrentLocationAddress(position.coords.latitude, position.coords.longitude);
                        }
                    });
                } else {

                    // obtain address
                    self.obtainCurrentLocationAddress(position.coords.latitude, position.coords.longitude);
                }
            }

            function geolocationError() {
                CONFUSEDPETROLPRICES.Utils.WriteNewRelicPageEvent('CurrentPositionFailed');

                // confirm postcode not already updated with My Location
                if (self.Postcode() === ns.Constants.MyLocation) {
                    return;
                }

                self.handleCurrentLocationFault(ns.Constants.CurrentLocationError);
            }

            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                    processGeolocation,
                    geolocationError,
                    {
                        timeout: 5000,
                        enableHighAccuracy: true,
                        maximumAge: 0
                    });
            } else {
                CONFUSEDPETROLPRICES.Utils.WriteNewRelicPageEvent('CurrentPositionUnavailable');
                self.handleCurrentLocationFault(ns.Constants.CurrentLocationUnavailable);
            }

            return false;
        };

        // obtain current location address
        self.obtainCurrentLocationAddress = function (lat, lng) {

            // set up Google Geocoder
            var geocoder = new google.maps.Geocoder();

            // handle reverse geocoding
            geocoder.geocode({ 'location': { lat: parseFloat(lat), lng: parseFloat(lng) } }, function (results, status) {

                var placePostcode = null;
                if (status === 'OK' && results[0]) {

                    // loop through results
                    $.each(results, function () {

                        var place = this;
                        if (place.address_components !== null && place.address_components !== undefined) {

                            // obtain postcode
                            $.each(place.address_components, function () {
                                if (this.types[0] &&
                                    this.types[0] === 'postal_code' &&
                                    this.types[0].replace(/\s/g, '').length > 4) {

                                    placePostcode = this.short_name;
                                    return false;
                                }
                            });
                        }

                        if (placePostcode !== null) {
                            return false;
                        }
                    });
                }

                // update postcode field
                if (placePostcode !== null) {
                    self.Postcode(placePostcode);
                    CONFUSEDPETROLPRICES.submitPageEvent({ EventType: 'petrolprices:currentlocation:geocoder', EventInfo: { 'Status': 'Postcode retrieved: ' + placePostcode } });
                    CONFUSEDPETROLPRICES.Utils.WriteNewRelicPageEvent('GeocoderPostcodeRetrieved');
                } else {
                    self.Postcode(ns.Constants.MyLocation);
                    self.PostcodeLatitude(lat);
                    self.PostcodeLongitude(lng);
                    CONFUSEDPETROLPRICES.submitPageEvent({ EventType: 'petrolprices:currentlocation:geocoder', EventInfo: { 'Status': 'Postcode not retrieved' } });
                    CONFUSEDPETROLPRICES.Utils.WriteNewRelicPageEvent('GeocoderPostcodeNotRetrieved');
                }

                // clear postcode validation
                $(ns.Elements.SFPostcodeError).html('');
                $(ns.Elements.SFPostcodeError).hide();

                $(ns.Elements.RSPostcodeError).html('');
                $(ns.Elements.RSPostcodeError).hide();
            });
        };

        // handle current location fault
        self.handleCurrentLocationFault = function (faultMessage) {
            if (self.currentStep() === 1) {
                $(ns.Elements.SFPostcodeError).html(faultMessage);
                $(ns.Elements.SFPostcodeError).show();
            } else {
                $(ns.Elements.RSPostcodeError).html(faultMessage);
                $(ns.Elements.RSPostcodeError).show();
            }
        };

        // filter 'get prices by radius' button
        self.getPricesByRadius = function (requestSource) {

            // ensure safari on mac yielding postcode
            if(CONFUSEDPETROLPRICES.isSafariOnMac()) {
                self.Postcode($(ns.Elements.RSPostcode).val());
            }

            // obtain form values
            var fuelType = self.FuelType();
            var radius = self.Radius();
            var postcode = self.Postcode();
            var postcodeLatitude = self.PostcodeLatitude();
            var postcodeLongitude = self.PostcodeLongitude();

            // validate form
            if (CONFUSEDPETROLPRICES.validateRadiusSearch(fuelType, radius, postcode, postcodeLatitude, postcodeLongitude) === false) {
                return false;
            }

            // get price list
            self.GetPriceList(fuelType, radius, postcode, postcodeLatitude, postcodeLongitude, requestSource);
            return false;
        };

        self.getDomain = function() {
            if (self._getDomain === undefined) {
                var hostNameArray = window.location.hostname.split('.');
                var hostName = '';
                for (var i = 1; i < hostNameArray.length; i++)
                {
                    hostName = hostName.concat('.' + hostNameArray[i]);
                }
                self._getDomain = hostName;
            }
            return self._getDomain;
        };

        // request prices
        self.GetPriceList = function (fuelType, radius, postcode, postcodeLatitude, postcodeLongitude, requestSource) {

            // if unathenticated user
            var unauthenticatedUserPricesNumberOfRequests = 0;
            if (self.IsAuthenticatedUser() === false) {

                // get state via auth prompt cookie (create cookie if not present) 
                if (Confused.CookieManager.prototype.hasItem(ns.Constants.AuthPromptCookieName)) {
                    var authPromptCookieValue = Confused.CookieManager.prototype.getItem(ns.Constants.AuthPromptCookieName);
                    unauthenticatedUserPricesNumberOfRequests = authPromptCookieValue.split(',')[0];
                } else {
                    Confused.CookieManager.prototype.setItem(ns.Constants.AuthPromptCookieName, '0,,', null, '/', self.getDomain());
                }
            }

            // only send lat/lng if 'My location'
            if (postcode !== ns.Constants.MyLocation) {
                postcodeLatitude = null;
                postcodeLongitude = null;
            }

            // hide results panel border
            CONFUSEDPETROLPRICES.hideResultsPanelBorder();

            // hide opening hours modal
            CONFUSEDPETROLPRICES.openingHoursModalCloseClick();

            // disable postcode error
            CONFUSEDPETROLPRICES.disablePostcodeError();

            // display 'please wait...'
            self.currentStep(8);

            // enable 'is searching'
            if (self.IsSearching()) {
                return;
            }
            self.IsSearching(true);

            // make ajax request for prices
            $.ajax({
                url: '/api/petrolv2/petrolprices/GetPriceList',
                data: ko.toJSON({
                    FuelType: fuelType, Radius: radius, Postcode: postcode, PostcodeLatitude: postcodeLatitude,
                    PostcodeLongitude: postcodeLongitude, UnauthenticatedUserPricesNumberOfRequests: unauthenticatedUserPricesNumberOfRequests,
                    RequestSource: requestSource
                }),
                type: 'POST',
                contentType: 'text/json',
                success: function (priceList) {

                    // disable 'is searching'
                    self.IsSearching(false);

                    // handle retrieved price list
                    self.handleRetrievedPriceList(priceList);
                },
                error: function () {

                    // disable 'is searching'
                    self.IsSearching(false);

                    // handle retrieved price list error
                    self.handleRetrievedPriceListError();
                },
                timeout: 20000
            });
        };

        // request price statistics
        self.GetPriceStatistics = function () {

            // make ajax request for prices
            $.ajax({
                url: '/api/petrolv2/petrolprices/GetPriceStatistics',
                data: ko.toJSON({}),
                type: 'POST',
                contentType: 'text/json',
                success: function (priceStatistics) {

                    if (priceStatistics == null || priceStatistics.PetrolLastUpdated == null) {
                        return;
                    }

                    // set price statistics
                    self.PetrolHighest(ns.Utils.FormatPriceStatistic(priceStatistics.PetrolHighest));
                    self.PetrolLowest(ns.Utils.FormatPriceStatistic(priceStatistics.PetrolLowest));
                    self.PetrolAverage(ns.Utils.FormatPriceStatistic(priceStatistics.PetrolAverage));
                    self.PetrolLastUpdated(ns.Utils.FormatPriceStatistic(priceStatistics.PetrolLastUpdated));
                    self.DieselHighest(ns.Utils.FormatPriceStatistic(priceStatistics.DieselHighest));
                    self.DieselLowest(ns.Utils.FormatPriceStatistic(priceStatistics.DieselLowest));
                    self.DieselAverage(ns.Utils.FormatPriceStatistic(priceStatistics.DieselAverage));
                    self.DieselLastUpdated(ns.Utils.FormatPriceStatistic(priceStatistics.DieselLastUpdated));

                    // set authentication state
                    self.IsAuthenticatedUser(priceStatistics.IsAuthenticatedUser);
                },
                error: function () {
                },
                timeout: 20000
            });
        };



        // handle retrieved price list
        self.handleRetrievedPriceList = function (priceList) {

            // 1. if error
            if (priceList.result === false) {
                self.handleRetrievedPriceListError();
                return;
            }

            // update authentication state
            self.IsAuthenticatedUser(priceList.IsAuthenticatedUser);

            // bind postcode lat/lgn
            self.PostcodeLatitude(priceList.PostcodeLatitude);
            self.PostcodeLongitude(priceList.PostcodeLongitude);

            // bind number of prices within radius
            self.NumberOfPricesWithin5Miles(priceList.NumberOfPricesWithin5Miles);
            self.NumberOfPricesWithin10Miles(priceList.NumberOfPricesWithin10Miles);
            self.NumberOfPricesWithin25Miles(priceList.NumberOfPricesWithin25Miles);

            // ensure open now filter unchecked
            $(ns.Elements.IsOpenFilter).attr('checked', false);

            // if authenticated user
            if (self.IsAuthenticatedUser()) {

                // remove auth prompt cookie, if present
                if (Confused.CookieManager.prototype.hasItem(ns.Constants.AuthPromptCookieName)) {
                    Confused.CookieManager.prototype.removeItem(ns.Constants.AuthPromptCookieName, '/', self.getDomain());
                }

                // 2. if capped (without prices)
                if (priceList.IsAuthenticatedUserPricesRequestsCapped === true) {

                    // do not display filter
                    self.currentFilter(0);

                    // display 'notification' header
                    self.currentHeader(3);

                    // display 'searches used up' notification bar
                    self.currentNotificationBar(1);

                    // display 'notification panel' step
                    self.currentStep(7);

                    // display 'authenticated user searches used up' notification panel
                    self.currentNotificationPanel(1);

                    // showing number of prices
                    self.showingNumberOfPrices(0);
                }

                // 3. if postcode not found
                else if (priceList.PostcodeLatitude === 0 || priceList.PostcodeLongitude === 0) {

                    // do not display filter
                    self.currentFilter(0);

                    // display 'radius search' header
                    self.currentHeader(1);

                    // display 'stations' radius search
                    self.currentRadiusSearch(1);

                    // display 'notification panel' step
                    self.currentStep(7);

                    // display 'authenticated user postcode not found' notification panel
                    self.currentNotificationPanel(4);

                    // showing number of prices
                    self.showingNumberOfPrices(0);
                }

                // 4. if no prices
                else if (jQuery.isEmptyObject(priceList.JsonViewPrices)) {

                    // do not display filter
                    self.currentFilter(0);

                    // display 'radius search' header
                    self.currentHeader(1);

                    // display 'stations' radius search
                    self.currentRadiusSearch(1);

                    // display 'no prices' step
                    self.currentStep(4);

                    // display 'authenticated user' no prices
                    self.currentNoPrices(1);

                    // showing number of prices
                    self.showingNumberOfPrices(0);
                }

                // 5. if cap notification (with prices)
                else if (priceList.AuthenticatedUserPricesRequestsRemaining === 0) {

                    // display filter
                    self.currentFilter(1);

                    // display 'notification' header
                    self.currentHeader(3);

                    // display 'last search used up' notification bar
                    self.currentNotificationBar(2);

                    // display 'price list' step
                    self.currentStep(2);

                    // handle retrieved prices
                    self.handleRetrievedPrices(priceList.JsonViewPrices);
                }

                // 6. otherwise prices
                else {

                    // display filter
                    self.currentFilter(1);

                    // display 'radius search' header
                    self.currentHeader(1);

                    // display 'stations' radius search
                    self.currentRadiusSearch(1);

                    // display 'price list' step
                    self.currentStep(2);

                    // handle retrieved prices
                    self.handleRetrievedPrices(priceList.JsonViewPrices);

                    // showing number of prices
                    self.showingNumberOfPrices(self.countNumberOfPricesExcludingMock());
                }
            }

            // if unauthenticated user
            else {

                // display 'login' header
                self.currentHeader(2);

                // 2. if capped (without prices)
                if (priceList.IsUnauthenticatedUserPricesRequestsCapped === true) {

                    // display 'searches used up' login
                    self.currentLogin(1);

                    // display 'notification panel' step
                    self.currentStep(7);

                    // display 'unauthenticated user searches used up' notification panel
                    self.currentNotificationPanel(2);
                }

                // 3. if postcode not found
                else if (priceList.PostcodeLatitude === 0 || priceList.PostcodeLongitude === 0) {

                    // display 'postcode not found' login
                    self.currentLogin(4);

                    // display 'notification panel' step
                    self.currentStep(7);

                    // display 'unauthenticated user postcode not found' notification panel
                    self.currentNotificationPanel(5);
                }

                // 4. if no prices
                else if (jQuery.isEmptyObject(priceList.JsonViewPrices)) {

                    // display 'no prices' login
                    self.currentLogin(3);

                    // display 'no prices' step
                    self.currentStep(4);

                    // display 'unauthenticated user' no prices
                    self.currentNoPrices(2);
                }

                // 5. otherwise prices (update state via auth prompt cookie)
                else {

                    // update auth prompt cookie (state, fuel type and postcode)
                    var unauthenticatedUserPricesNumberOfRequests = 0;

                    if (Confused.CookieManager.prototype.hasItem(ns.Constants.AuthPromptCookieName)) {
                        var authPromptCookieValue = Confused.CookieManager.prototype.getItem(ns.Constants.AuthPromptCookieName);
                        unauthenticatedUserPricesNumberOfRequests = parseInt(authPromptCookieValue.split(',')[0]);
                    }

                    unauthenticatedUserPricesNumberOfRequests++;

                    var authPromptCookieUpdatedValue = unauthenticatedUserPricesNumberOfRequests + ',' + self.FuelType() + ',' + self.Postcode();
                    Confused.CookieManager.prototype.setItem(ns.Constants.AuthPromptCookieName, authPromptCookieUpdatedValue, null, '/', self.getDomain());

                    // display 'searches used up' login
                    self.currentLogin(1);

                    // display 'price list' step
                    self.currentStep(2);

                    // handle retrieved prices
                    self.handleRetrievedPrices(priceList.JsonViewPrices);
                }
            }

            return;
        };

        // handle retrieved price list
        self.handleRetrievedPriceListError = function () {

            // if authenticated user (prior to request for prices)
            if (self.IsAuthenticatedUser()) {

                // do not display filter
                self.currentFilter(0);

                // display 'radius search' header
                self.currentHeader(1);

                // display 'stations' radius search
                self.currentRadiusSearch(1);

                // display 'price list error' step
                self.currentStep(5);

                // display 'authenticated user' price list error
                self.currentPriceListError(1);

                // showing number of prices
                self.showingNumberOfPrices(0);

            // if unauthenticated user (prior to request for prices)
            } else {

                // display 'login' header
                self.currentHeader(2);

                // display 'on error' login
                self.currentLogin(2);

                // display 'price list error' step
                self.currentStep(5);

                // display 'unauthenticated user' price list error
                self.currentPriceListError(2);
            }
        };

        // handle retrieved prices
        self.handleRetrievedPrices = function (prices) {

            // show results panel border
            CONFUSEDPETROLPRICES.showResultsPanelBorder();

            // clear existing prices
            self.Prices.removeAll();

            // bind retrieved prices
            $.each(prices, function (index, price) {
                if (price !== false) {
                    var modelPrice = new ns.Price();

                    var jsonPrice = $.parseJSON(price);
                    ns.Utils.BindPrice(modelPrice, jsonPrice);

                    self.Prices.push(modelPrice);
                }
            });

            // sort by cheapest price
            self.sortPricesByCheapest();

            // scrollable prices on load
            CONFUSEDPETROLPRICES.scrollablePricesOnRender(self.countNumberOfPrices());
        };

        // get embedded map directions to petrol station
        self.getDirections = function (stationLatitude, stationLongitude) {

            // get directions api link
            var directionsApiLink = $(ns.Elements.DirectionsApiLink);
            if (directionsApiLink.length === 0) {
                return;
            }

            var directionsApiLinkValue = directionsApiLink.val();

            // if directions api link available, use it to get script
            if (directionsApiLinkValue) {

                $.ajax({
                type: 'GET',
                url: directionsApiLinkValue,
                dataType: 'script',
                cache: true,
                success: function () {

                        // clear directions api link once script retrieved
                        $(ns.Elements.DirectionsApiLink).val('');

                        // handle directions
                        self.handleDirections(stationLatitude, stationLongitude);
                    }
                });
            } else {

                // handle directions
                self.handleDirections(stationLatitude, stationLongitude);
            }
        };

        // handle embedded map directions to petrol station
        self.handleDirections = function (stationLatitude, stationLongitude) {

            // make ajax request for whether directions enabled
            $.ajax({
                url: '/api/petrolv2/petrolprices/IsDirectionsEnabled',
                data: ko.toJSON({}),
                type: 'POST',
                contentType: 'text/json',
                success: function (directions) {

                    // if error
                    if (directions.result === false) {
                        self.handleRetrievedDirectionsError();
                        return;
                    }

                    // if directions enabled
                    if (directions.IsEnabled) {

                        // handle prices form to directions
                        CONFUSEDPETROLPRICES.pricesFormToDirections();

                        // render map
                        if (self.DirectionsMap === '') {
                            self.DirectionsMap = CONFUSEDPETROLPRICES.initDirectionsMap();
                        }

                        if (self.DirectionsRenderer === '') {
                            self.DirectionsRenderer = CONFUSEDPETROLPRICES.initDirectionsRenderer();
                        }

                        CONFUSEDPETROLPRICES.renderDirections(
                            self.PostcodeLatitude(),
                            self.PostcodeLongitude(),
                            stationLatitude(),
                            stationLongitude(),
                            self.DirectionsMap,
                            self.DirectionsRenderer);

                        // hide filter
                        self.currentFilter(0);

                        // display 'close map' radius search
                        self.currentRadiusSearch(2);

                        // display 'directions' step
                        self.currentStep(3);

                    // if directions not enabled
                    } else {

                        // hide filter
                        self.currentFilter(0);

                        // display 'close map' radius search
                        self.currentRadiusSearch(2);

                        // display 'notification panel' step
                        self.currentStep(7);

                        // display 'directions used up' notification panel
                        self.currentNotificationPanel(3);
                    }
                },
                error: function () {
                    self.handleRetrievedDirectionsError();
                },
                timeout: 20000
            });

        };

        // handle retrieved directions error
        self.handleRetrievedDirectionsError = function () {

            // hide filter
            self.currentFilter(0);

            // display 'close map' radius search
            self.currentRadiusSearch(2);

            // display 'directions error' step
            self.currentStep(6);
        };

        // tab google map for directions to petrol station
        self.getTabbedDirections = function (stationLatitude, stationLongitude) {

            // construct maps querystring
            var mapsQueryString =
                'saddr=' + self.PostcodeLatitude() + ',' + self.PostcodeLongitude() +
                '&daddr=' + stationLatitude() + ',' + stationLongitude();

            // open map in suitable device
            var win;
            var mapsUrl;
            if ((navigator.platform.indexOf(ns.Constants.IPhone) !== -1) ||
                (navigator.platform.indexOf(ns.Constants.IPod) !== -1) ||
                (navigator.platform.indexOf(ns.Constants.IPad) !== -1)) {

                mapsUrl = ns.Constants.AppleMaps + mapsQueryString;
                win = window.open(mapsUrl, '_system');
            } else if (navigator.platform.indexOf(ns.Constants.Android) !== -1) {

                mapsUrl = ns.Constants.AndroidMaps + mapsQueryString;
                win = window.open(mapsUrl);
            } else {

                mapsUrl = ns.Constants.HttpsMaps + mapsQueryString;
                win = window.open(mapsUrl, '_blank');
            }

            // confirm map opened okay
            if (win) {

                // log tabbed directions map 'permitted'
                CONFUSEDPETROLPRICES.submitPageEvent({
                    EventType: 'petrolprices:tabbeddirections:permitted', EventInfo: { 'MapsUrl': mapsUrl }
                });

                win.focus();
            } else {

                // log tabbed directions map 'not permitted'
                CONFUSEDPETROLPRICES.submitPageEvent({
                    EventType: 'petrolprices:tabbeddirections:notpermitted', EventInfo: { 'MapsUrl': mapsUrl }
                });
            }
        };

        // show opening hours modal
        self.showOpeningHours = function (openingHoursText, automatService) {
            self.ModalOpeningHoursText(openingHoursText());
            self.ModalOpeningHoursAutomatService(automatService);
            CONFUSEDPETROLPRICES.openingHoursLinkClick();

            // log 'show opening hours' click
            CONFUSEDPETROLPRICES.submitPageEvent({
                EventType: 'petrolprices:openinghours:show', EventInfo: {}
            });
        };

        // close opening hours modal
        self.closeOpeningHours = function () {
            self.ModalOpeningHoursText('');
            self.ModalOpeningHoursAutomatService(false);
            CONFUSEDPETROLPRICES.openingHoursModalCloseClick();
        };

        // sort by cheapest price
        self.sortPricesByCheapest = function () {

            // sort by distance then cheapest
            ns.Utils.SortPricesByDistance(self);
            ns.Utils.SortPricesByCheapest(self);

            // set 'sort prices by cheapest' link to active
            $(ns.Elements.SortPricesByCheapest).addClass(ns.Classes.ResultsFilterActive);
            $(ns.Elements.SortPricesByDistance).removeClass(ns.Classes.ResultsFilterActive);
        };

        // sort by closest price
        self.sortPricesByDistance = function () {

            // sort by cheapest then distance
            ns.Utils.SortPricesByCheapest(self);
            ns.Utils.SortPricesByDistance(self);

            // set 'sort prices by distance' link to active
            $(ns.Elements.SortPricesByDistance).addClass(ns.Classes.ResultsFilterActive);
            $(ns.Elements.SortPricesByCheapest).removeClass(ns.Classes.ResultsFilterActive);
        };

        // count number of prices (including mock prices)
        self.countNumberOfPrices = function () {
            var count = 0;

            $.each(self.Prices(), function (index, price) {
                if(price.Enabled()) {
                    count++;
                }
            });

            return count;
        };

        // count number of prices (excluding mock prices)
        self.countNumberOfPricesExcludingMock = function () {
            var count = 0;

            $.each(self.Prices(), function (index, price) {
                if (price.Enabled() && (price.PriceType() !== ns.Constants.PriceTypeMock)) {
                    count++;
                }
            });

            return count;
        };

        // showing number of prices
        self.showingNumberOfPrices = function (numberOfPrices) {

            // get text
            var showingNumberOfPricesTokenizedText = $(ns.Elements.ShowingNumberOfPricesTokenized).val();

            // replace token with number of prices
            var showingNumberOfPricesText = showingNumberOfPricesTokenizedText.replace(ns.Tokens.NumberOfPrices, numberOfPrices);

            // replace plural if only 1 price 
            if (numberOfPrices === 1) {
                showingNumberOfPricesText = showingNumberOfPricesText.replace(ns.Constants.Stations, ns.Constants.Station);
            }

            // set text
            $(ns.Elements.ShowingNumberOfPrices).text(showingNumberOfPricesText);
        };

        // handle auth prompt cookie
        self.handleAuthPromptCookie = function () {

            // get fuel type and postcode
            var fuelType = null;
            var postcode = null;

            if (Confused.CookieManager.prototype.hasItem(ns.Constants.AuthPromptCookieName)) {
                var authPromptCookieValue = Confused.CookieManager.prototype.getItem(ns.Constants.AuthPromptCookieName);
                fuelType = parseInt(authPromptCookieValue.split(',')[1]);
                postcode = authPromptCookieValue.split(',')[2];
            }

            // if fuel type and postcode found...
            if ((fuelType != null && fuelType !== '') &&
                (postcode != null && postcode !== '' && postcode !== ns.Constants.MyLocation)) {

                // store fuel type and postcode
                self.FuelType(fuelType);
                self.Postcode(postcode);

                // get prices
                self.getPrices(ns.Constants.RequestSourceAutoSearch);
            }
        };

        // 'directions back to prices' button
        self.directionsBackToPrices = function () {
            // display 'price list' step
            self.currentStep(2);

            // display filter
            self.currentFilter(1);

            // display 'stations' radius search
            self.currentRadiusSearch(1);

            // handle directions form to prices
            CONFUSEDPETROLPRICES.directionsFormToPrices();
        };

        // 'prices back to search' button
        self.pricesBackToSearch = function () {

            // hide 'login' header
            self.currentHeader(0);

            // display 'search form' step
            self.currentStep(1);

            // handle prices form to search
            CONFUSEDPETROLPRICES.pricesFormToSearch();
        };

        // 'show more results' button
        self.showMoreResults = function () {

            // update to wider radius
            var currentRadius = parseInt(self.Radius());

            if (currentRadius === ns.Constants.Radius5Miles && self.NumberOfPricesWithin10Miles() > self.NumberOfPricesWithin5Miles()) {
                self.Radius(ns.Constants.Radius10Miles);
            } else if (currentRadius === ns.Constants.Radius5Miles && self.NumberOfPricesWithin25Miles() > self.NumberOfPricesWithin5Miles()) {
                self.Radius(ns.Constants.Radius25Miles);
            } else if (currentRadius === ns.Constants.Radius10Miles && self.NumberOfPricesWithin25Miles() > self.NumberOfPricesWithin10Miles()) {
                self.Radius(ns.Constants.Radius25Miles);
            }

            // get prices
            self.getPricesByRadius(ns.Constants.RequestSourceShowMoreResults);
        };

        // bind events
        self.bindEvents = function () {

            // only show prices from currently open petrol stations
            $(ns.Elements.IsOpenFilter).change(function () {

                var filterOn = $(this).is(':checked');

                if (filterOn) {
                    $.each(self.Prices(), function (index, price) {
                        if (price.IsOpen() === false) {
                            price.Enabled(false);
                        }
                    });
                } else {
                    $.each(self.Prices(), function (index, price) {
                        price.Enabled(true);
                    });
                }
                
                // show number of prices
                self.showingNumberOfPrices(self.countNumberOfPricesExcludingMock());

                // scrollable prices on open filter
                CONFUSEDPETROLPRICES.scrollablePricesOnRender(self.countNumberOfPrices());

                // log 'is open' click
                CONFUSEDPETROLPRICES.submitPageEvent({
                    EventType: 'petrolprices:filter:filterpricesbyisopen', EventInfo: { 'FilterOn': filterOn }
                });

            });

            // only show search form postcode section on fuel type selection
            $('input[type=radio][name=sfFuelType]').change(function () {
                CONFUSEDPETROLPRICES.showSearchFormPostcodeSection();
            });
        };

        // init on page load
        self.initOnPageLoad = function () {

            setTimeout(function(){

                // get price statistics
                self.GetPriceStatistics();

                // init MI events
                CONFUSEDPETROLPRICES.initEventDecorator();

                // init events
                self.bindEvents();

                // init validation
                CONFUSEDPETROLPRICES.bindValidation();

                // init tooltips
                CONFUSEDPETROLPRICES.initTooltips();

                // initialise opening hours
                CONFUSEDPETROLPRICES.initOpeningHours();

                // initialise internet explorer
                CONFUSEDPETROLPRICES.initInternetExplorer();

                // initialise safari
                CONFUSEDPETROLPRICES.initSafariOnMac();

                // init values
                self.Radius($(ns.Elements.SFRadius).val());

                // handle auth prompt cookie
                self.handleAuthPromptCookie();

            }, 200);
        };

        // scrollable prices on right link
        $(ns.Elements.ScrollPricesRightLink).click(function (e) {
            CONFUSEDPETROLPRICES.scrollablePricesOnRightClick(e);
        });

        // scrollable prices on left click
        $(ns.Elements.ScrollPricesLeftLink).click(function (e) {
            CONFUSEDPETROLPRICES.scrollablePricesOnLeftClick(e);
        });

        // submit search form on postcode enter key
        $(ns.Elements.SFPostcode).keyup(function (e) {
            if (e.keyCode === 13) {
                self.getPrices(ns.Constants.RequestSourceSearchForm);
            }
        });

        // submit results form on postcode enter key
        $(ns.Elements.RSPostcode).keyup(function (e) {
            if (e.keyCode === 13) {
                self.getPricesByRadius(ns.Constants.RequestSourceResultsForm);
            }
        });

        // on window resize
        $(window).resize(function () {

            // scrollable prices on window resize
            CONFUSEDPETROLPRICES.scrollablePricesOnRender(self.countNumberOfPrices());
        });
    };

    // set up petrol prices form
    if ($(ns.Elements.PetrolPriceCalculator).length > 0) {
        var petrolPricesForm = new CONFUSEDPETROLPRICES.PetrolPricesForm();
        petrolPricesForm.Initialise();
    }

})(CONFUSEDPETROLPRICES, jQuery);



